import React, { Fragment, useState, useEffect } from 'react';

export default function GatsbyShitheadFix({ children }) {
  const [key, setKey] = useState('server');
  useEffect(() => setKey('client'), []);
  return <Fragment key={key}>{children}</Fragment>;
}
